import React from "react";
import {
    MetadataRenderer,
    sortMetadataKeys
} from "../utils/DisplayHelpers";
import { findCommonKeys } from "../utils/HelperFunctions";
import { DeviceRouteHop, RouteHopFactory } from "./TrailblazerRouteHop";
import RouteMetadataService from "../utils/RouteMetadataService";

/**
 * This class handles how the data is displayed in the TrailblazerTable.
 */
export default class TrailblazerTableData {
    constructor(route) {
        this.route = null;
        this.tableItems = [];
        this.columnDefinitions = [];
        this.columnDisplay = [];
        const { sortedMetadata, renderableMetadata } = RouteMetadataService.processRouteMetadata(route);

        this.sortedMetadata = sortedMetadata;
        this.renderableMetadata = renderableMetadata;

        if (route) {
            this.initializeTableData(route);
        }
    }

    initializeTableData(route) {
        if (!route) {
            return;
        }
        this.route = route;

        if (route.hops) {
            this.generateTableDataForRoute(route);
        }
    }

    hasMetadata() {
        return RouteMetadataService.hasMetadata(this.route, this.sortedMetadata);
    }

    getRenderedMetadata() {
        return this.renderableMetadata;
    }

    getTableData() {
        return {
            tableItems: this.tableItems,
            columnDefinitions: this.columnDefinitions,
            columnDisplay: this.columnDisplay
        };
    }

    /**
     * Given a route, generate the table data.
     */
    generateTableDataForRoute = (route) => {
        const routeHops = route.hops.map(hop => RouteHopFactory.createHop(hop));

        const routeDataObjects = routeHops.map(transformedHop => transformedHop.toTableData());

        const commonKeys = findCommonKeys(routeDataObjects);
        const sortedCommonKeys = sortMetadataKeys(commonKeys, DeviceRouteHop.METADATA_INFORMATION);

        const columnDefinitions = sortedCommonKeys.map((key) => {
            const config = DeviceRouteHop.METADATA_INFORMATION[key];
            const displayName = config?.displayName || key;

            return {
                id: key,
                header: displayName,
                cell: item => <MetadataRenderer fieldName={key} value={item[key]}/>
            };
        });

        const tableItems = routeDataObjects.map((dataObject, index) => ({
            id: `hop-${index}`,
            ...dataObject
        }));

        const columnDisplay = columnDefinitions.map(column => ({
            id: column.id,
            visible: true
        }));

        this.tableItems = tableItems;
        this.columnDefinitions = columnDefinitions;
        this.columnDisplay = columnDisplay;
    };
}